import { Paper } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import React from "react";
import ContactImport from "../../components/ContactImport";
import MainContainer from "../../components/MainContainer";
import MainHeader from "../../components/MainHeader";
import Title from "../../components/Title";

const useStyles = makeStyles(theme => ({
    mainPaper: {
        flex: 1,
        padding: 1,
        borderRadius: 0,
        overflowY: "scroll",
        ...theme.scrollbarStylesSoftBig
    },
}));

const ContactImportPage = () => {
    const classes = useStyles();
    return <MainContainer className={classes.mainContainer}>
        <MainHeader>
            <Title>📥 Importar Contatos de Arquivo</Title>
        </MainHeader>
        <Paper
            className={classes.mainPaper}
            variant="outlined"
            style={{ 
                borderRadius: 12,
                boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
            }}>
            <ContactImport />
        </Paper>
    </MainContainer>
}

export default ContactImportPage;